import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ind-card" },
    [
      _c("div", { staticClass: "ind-card-header" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm.type === "count"
        ? [
            _vm._m(0),
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                { key: item.row_number, staticClass: "count-row" },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { bottom: "", disabled: !item.fecha },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "span",
                                  _vm._g(
                                    _vm._b(
                                      { staticClass: "brand-name" },
                                      "span",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      _vm._s(item.row_number) +
                                        ". " +
                                        _vm._s(item.negocio)
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v("Dato a: " + _vm._s(_vm.fechaLabel(item))),
                      ]),
                    ]
                  ),
                  _c("span", { staticClass: "count-val" }, [
                    _vm._v(_vm._s(_vm.fmtCount(item.valor))),
                  ]),
                ],
                1
              )
            }),
            _vm.totalItem
              ? _c("div", { staticClass: "count-row total-row" }, [
                  _c("span", { staticClass: "brand-name" }, [_vm._v("TOTAL")]),
                  _c("span", { staticClass: "count-val" }, [
                    _vm._v(_vm._s(_vm.fmtCount(_vm.totalItem.total_valor))),
                  ]),
                ])
              : _vm._e(),
          ]
        : _vm.type === "percent"
        ? [
            _vm._m(1),
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                { key: item.row_number, staticClass: "pct-row" },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { bottom: "", disabled: !item.fecha },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "span",
                                  _vm._g(
                                    _vm._b(
                                      { staticClass: "brand-name" },
                                      "span",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      _vm._s(item.row_number) +
                                        ". " +
                                        _vm._s(item.negocio)
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v("Dato a: " + _vm._s(_vm.fechaLabel(item))),
                      ]),
                    ]
                  ),
                  _c("span", { staticClass: "pct-val" }, [
                    _vm._v(_vm._s(_vm.fmtScore(item.valor))),
                  ]),
                ],
                1
              )
            }),
            _vm.totalItem
              ? _c("div", { staticClass: "pct-row avg-row" }, [
                  _c("span", { staticClass: "brand-name" }, [
                    _vm._v("PROMEDIO"),
                  ]),
                  _c("span", { staticClass: "pct-val" }, [
                    _vm._v(_vm._s(_vm.fmtScore(_vm.totalItem.total_valor))),
                  ]),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "count-col-labels" }, [
      _c("span", [_vm._v("Negocio")]),
      _c("span", { staticClass: "text-right" }, [_vm._v("#")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pct-col-labels" }, [
      _c("span", [_vm._v("Negocio")]),
      _c("span", { staticClass: "text-right" }, [_vm._v("Score")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }